import React, { lazy } from "react";
import { Helmet } from "react-helmet";
const Header = lazy(() => import("../../components/webinar/Header"));
const Description = lazy(() => import("../../components/webinar/Description"));
const Offer = lazy(() => import("../../components/webinar/Offer"));
const Prefooter = lazy(() => import("../../components/webinar/Prefooter"));
const Services = lazy(() => import("../../components/webinar/Services"));
const Testimonials = lazy(() =>
  import("../../components/webinar/Testimonials")
);
const Footer = lazy(() => import("../../components/shared/Footer"));
const LegalProAdvisor = lazy(() => import("../../components/webinar/LegalProAdvisor"));

function WebinarHomeScreen() {
  return (
    <div>
      <Helmet>
        <title>
          Contract Bazaar | Best Legal Management Services for Business
        </title>
      </Helmet>
      <Header />
      <Description />
      <Offer />
      <LegalProAdvisor />
      <Services />
      <Testimonials />
      <Prefooter />
      <Footer />
    </div>
  );
}

export default WebinarHomeScreen;
